/**
 * Customized to align react styles
 */

import { SxProps, Theme } from '@mui/material';

export const submitActionSX: SxProps<Theme> = (theme) => ({
	height: '42px',
	backgroundColor: theme.palette.primary.main,
	color: theme.palette.common.white,
	border: 'none',
	'&:hover': {
		backgroundColor: theme.palette.primary.dark,
		color: theme.palette.common.white,
		border: 'none',
	},
	'&.Mui-disabled': {
		backgroundColor: theme.palette.grey[50],
		color: theme.palette.grey[200],
		border: '1px solid ',
		borderColor: 'grey.100',
		cursor: 'not-allowed',
		borderRadius: '2px',
	},
});

export const cancelActionSX: SxProps<Theme> = (theme) => ({
	textDecoration: 'none',
	'&:hover': {
		textDecoration: 'underline',
		color: theme.palette.secondary.main,
	},
	color: theme.palette.secondary.main,
	py: '10px',
});
